import { createResource } from "solid-js";
import { listArtifactKinds } from "@/client";
import {
	FALLBACK_ARTIFACT_KINDS,
	indexArtifactKinds,
	resolveArtifactKindDisplay,
	type ArtifactKindDisplay,
} from "./artifactKindCatalog";

export function useArtifactKindCatalog() {
	const [kindCatalogResource] = createResource(async () => {
		const response = await listArtifactKinds();
		return indexArtifactKinds(
			response.data?.kinds?.length
				? response.data.kinds
				: FALLBACK_ARTIFACT_KINDS,
		);
	});

	const kindCatalog = () =>
		kindCatalogResource() ?? indexArtifactKinds(FALLBACK_ARTIFACT_KINDS);

	const displayKind = (
		kind: string | undefined,
		options?: { isCsvFile?: boolean },
	): ArtifactKindDisplay =>
		resolveArtifactKindDisplay(kindCatalog(), kind, options);

	return { kindCatalog, displayKind };
}
